"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextWithParsedCustomCurlyVariablesByDict = void 0;
function getTextWithParsedCustomCurlyVariablesByDict(text, variablesDict) {
    let parsedText = text;
    Object.entries(variablesDict).forEach(([variable, replacement]) => {
        parsedText = parsedText.replace(new RegExp(variable, 'g'), replacement); //replace all occurrences
    });
    return parsedText;
}
exports.getTextWithParsedCustomCurlyVariablesByDict = getTextWithParsedCustomCurlyVariablesByDict;
//# sourceMappingURL=getTextWithParsedCustomCurlyVariablesByDict.js.map